

module monitoringApp.controllers {

    class MainController {

        constructor(
            private $mdSideNav: angular.material.ISidenavService
        ) {
            var self = this;
        }
        static $inject = ['$mdSidenav'];

        toggleSideNav(): void {
            setTimeout( ()=>{
                this.$mdSideNav("left").toggle();
            }, 100);

        }

        openMenu(el): void {
            angular.element(el).toggleClass('open');
        }
    }

     angular.module("ultimateMonitoringApp").controller("mainController", MainController);
}


